"use client";

import React, { useState } from "react";
import { ContentfulInspectorManager } from "@packages/lib/contentful-preview/ContentfulInspector";
interface FaqComponentProps {
  faqData?: any;
  subheading?: string;
  componentData?: any;
  accordionOpeningType?: "single" | "multiple";
  iscontentPreview?: Boolean;
}
const Faqcomponents = ({
  faqData,
  subheading,
  componentData,
  accordionOpeningType = "single",
  iscontentPreview,
}: FaqComponentProps) => {
  const [openIndex, setOpenIndex] = useState<any[]>([]);
  const faqDatas =
    faqData?.bottomZoneComponentsCollection?.items?.[0]?.faqEntriesCollection
      ?.items ||
    faqData?.questions ||
    componentData?.faqEntriesCollection?.items;

  const handleAccordion = (index: number) => {
    if (accordionOpeningType === "single")
      setOpenIndex((prev) => {
        let temp = [...prev];
        temp[0] = temp[0] === index ? null : index;
        return temp;
      });
    else
      setOpenIndex((prev) => {
        let temp = [...prev];
        temp[index] = temp[index] === index ? null : index;
        return temp;
      });
  };

  if (!faqDatas) return <></>;

  const additionalFields = (faqDatas ?? []).map((item: any) => ({
    entryId: item?.sys?.id + "cpc_question",
    fieldId: "faqEntriesCollection",
    targetSelector: "#cpc_question",
  }));

  return (
    <>
      {iscontentPreview && (
        <ContentfulInspectorManager
          fields={[
            {
              entryId: componentData?.sys?.id,
              fieldId: "faqComponentTitle",
              targetSelector: "#cpc_faq",
            },
            ...additionalFields,
          ]}
        />
      )}
      <div className="faq-container bg-white">
        <div className="max-w-container mx-auto">
          <div className="faq-card-container flex flex-col gap-[32px] px-[16px] py-[40px] md:px-[20px] md:py-[64px] lg:px-[20px] xl:px-[0]">
            <div className="faq-header flex flex-col gap-[4px]">
              <div className="h2 font-bold" id="cpc_faq">
                {faqData?.pageTitle ||
                  componentData?.faqComponentTitle ||
                  "FAQs"}
              </div>
              <p className="font-normal small">
                {faqData?.subheading ||
                  faqData?.pageTitle ||
                  subheading ||
                  componentData?.description}
              </p>
            </div>
            <div className="accordion flex flex-col rounded-[6px] border border-grey-200 px-[16px]">
              {faqDatas?.map((item: any, index: any) => (
                <div
                  className="accordion-item flex flex-col border-b border-b-grey-200 last:border-b-0"
                  key={index}
                >
                  <div
                    className="accordion-header py-[16px] flex items-center justify-between gap-[48px] para font-semibold text-grey-600 cursor-pointer"
                    onClick={() => handleAccordion(index)}
                    id={item?.sys?.id + "faq_question"}
                  >
                    {item.question}
                    <svg
                      className={`min-w-[12px] transition-transform duration-300 ${openIndex[accordionOpeningType === "single" ? 0 : index] === index ? "rotate-180" : ""}`}
                      width="12"
                      height="7"
                      viewBox="0 0 12 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 1L6 6L1 1"
                        stroke="#82898F"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div
                    id={item?.sys?.id + "faq_question"}
                    className={`transition-all duration-300 overflow-hidden  ${openIndex[accordionOpeningType === "single" ? 0 : index] === index ? "max-h-screen" : "max-h-0"}`}
                  >
                    <div className="mb-[16px]">{item.answer}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faqcomponents;
